import { render, staticRenderFns } from "./history-redeem.vue?vue&type=template&id=b35c67bc&scoped=true&"
import script from "./history-redeem.vue?vue&type=script&lang=js&"
export * from "./history-redeem.vue?vue&type=script&lang=js&"
import style0 from "./history-redeem.vue?vue&type=style&index=0&id=b35c67bc&prod&scoped=true&lang=css&"
import style1 from "./history-redeem.vue?vue&type=style&index=1&id=b35c67bc&prod&lang=scss&scoped=true&"
import style2 from "./history-redeem.vue?vue&type=style&index=2&id=b35c67bc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b35c67bc",
  null
  
)

export default component.exports